module.exports = __webpack_public_path__ + "media/icon.png";


//////////////////
// WEBPACK FOOTER
// ../assets/media/brand/icon.png
// module id = 1167
// module chunks = 0